import React, { useState, useContext, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LanguageContext from '../../contexts/language';
import AuthContext from '../../contexts/auth';

export default function Login() {

    const { language } = useContext(LanguageContext);
    const lang = localStorage.getItem('language');

    const { signIn } = useContext(AuthContext);

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    function useQuery() {
        const { search } = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }
    let query = useQuery();

    const [email, setEmail] = useState('');
    const emailInput = useRef(null);

    const [error, setError] = useState(false);
    const [error_subs, setErrorSubs] = useState(false);
    const [error_message, setErrorMessage] = useState('');

    async function sendLogin(e){
        e.preventDefault();
        setLoading(true);

        if(email.trim() === ''){
            emailInput.current.focus();
            setLoading(false);
            setError(true);
            setErrorSubs(false);
            setErrorMessage(language.error_input_email);
            return;
        }

        try{

            const response = await signIn(email);
            
            setLoading(false);
            if (!response.user) {
                setError(false);
                setErrorSubs(true);
                setErrorMessage("");
                return;
            }

            if(query.get('redirect')==="" || query.get('redirect')===null || query.get('redirect')===undefined){
                navigate('/sala/26-maio');
            }else{
                navigate(query.get('redirect'));
            }

        }catch(err){
            setLoading(false);
            setError(true);
            setErrorSubs(false);
            setErrorMessage(language.error_login);
        }
    }

    return (
        <div className="page">
            <Header />
            <div className="content">
                <div className="full mt-80 mb-40 text-center">

                    <form onSubmit={sendLogin} className={`form ${ loading ? 'loading' : '' }`}>
                        <h3 className="title_b mb-60">
                            {language.login_title}
                        </h3>
                        {error_subs &&
                        <>
                            {lang==='pt' ?
                            <div className="mb-40">
                                <p className="text-alert mt-10 mb-20">Para assistir a programação você precisa<br />estar inscrito no FFCN 2025.</p>
                                <Link to="/inscricao" className="btn-send bg_color_4">Clique aqui e realize sua inscrição</Link>
                            </div>:
                            <div className="mb-40">
                                <p className="text-alert mt-10 mb-20">To watch the program you need<br />to be registered for FFCN 2025.</p>
                                <Link to="/inscricao" className="btn-send bg_color_4">Click here to register</Link>
                            </div>}
                        </>}
                        <div className="d-input">
                            <label>{language.email}:</label>
                            <input type="email" ref={emailInput} value={email} onChange={e => setEmail(e.target.value)} />
                        </div>

                        {error && <div className="error space mt-20 mb-20">{error_message}</div>}
                        <div className="d-btn mt-30">
                            <button type="submit" className="btn-send">{language.enter}</button>
                        </div>
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    );
}
